import { alpha } from '@mui/material/styles';

const getBgGradient = (color: string) =>
  `linear-gradient(180deg, ${alpha(color, 0.1)} 57%, ${alpha(color, 0)} 161%)`;

export const styles = {
  barWrapper: {
    height: '100%',
    flexGrow: 1,
    px: 0.125,
    cursor: 'default',
  },

  bar: ([bgColor, _]: [string, string], useGradient = false) => ({
    background: useGradient ? getBgGradient(bgColor) : alpha(bgColor, 0.8),
    transition: 'height 0.4s ease-out',
    width: '100%',
  }),

  barValue: ([bgColor, color]: [string, string], value: number | null) => ({
    position: 'relative',
    bgcolor: value !== null ? bgColor : 'transparent',
    height: '2px',

    '> *': {
      position: 'absolute',
      textAlign: 'center',
      bottom: '2px',
      left: 0,
      right: 0,

      '&:after': {
        content: '""',
        width: '0.625rem',
        height: '0.625rem',
        display: 'block',
        bgcolor: 'transparent',
        margin: '0 auto',
        border: `2px solid ${bgColor}`,
        borderRadius: '50%',
      },
    },

    '.MuiTypography-root': {
      bgcolor: bgColor,
      borderRadius: '0.25rem',
      p: '0.25rem',
      display: 'inline-block',
      color: color,
    },
  }),
};
